import React, { Component } from "react";
import Slider from "react-slick";
import Img1 from '../img/Group 7.2.png';
import Img3 from '../img/Group 6.2.png';
import Img2 from '../img/Group 8.2.png';
import ImgMobile1 from '../img/Mobile-Peak-Thrills.png';
import ImgMobile3 from '../img/Mobile-Wonders-in-the-wild.png';
import ImgMobile2 from '../img/Mobile-Chill-out-and-about.png';
import NextArrow from '../img/Arrow Right.png';
import PrevArrow from '../img/Arrow Left.png'
import { Link } from 'react-router-dom';

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <img className="arrow" src={NextArrow} />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}><img className="arrow" src={PrevArrow} /></div>
  );
}


export default class SimpleSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeSlide: 0,
      windowWidth: window.innerWidth,
    };

    this.slider = React.createRef();
    this.settings = {
      className: 'center',
      infinite: true,
      speed: 1500,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: "200px",
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
      beforeChange: (current, next) => {
        const numSlides = this.slides.length;
        const activeSlide = next % numSlides;
        this.setState({ activeSlide });
      },
      responsive: [
        {
          breakpoint: 980,
          settings: {
            centerPadding: "0px",
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            slides: [
              { image: ImgMobile1, link: '/peak-thrills-mobile'},
              { image: ImgMobile2, link: '/chill-out-and-about-mobile'},
              { image: ImgMobile3, link: '/wonders-in-the-wild-mobile'}
            ],
          }
        },
      ]
    };

    this.slides = [
      { desktopImage: Img1, mobileImage: ImgMobile1, link: '/peak-thrills' },
      { desktopImage: Img2, mobileImage: ImgMobile2, link: '/chill-out-and-about' },
      { desktopImage: Img3, mobileImage: ImgMobile3, link: '/wonders-in-the-wild' }
    ];
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    this.setState({ windowWidth: window.innerWidth });
  }

  render() {
    const { activeSlide, windowWidth } = this.state;
    const numSlides = this.slides.length;
    return (
      <section className="home-banner" data-aos="fade-up">
        <Slider {...this.settings} ref={this.slider}>
          {this.slides.map((slide, index) => {
            let className = 'slick-slide';

            if (activeSlide === 0 && index === numSlides - 1) {
              className += ' prev-slide';
            } else if (activeSlide > 0 && activeSlide - 1 === index) {
              className += ' prev-slide';
            } else if (activeSlide === index) {
              className += ' slick-active';
            } else if (activeSlide + 1 === index || (activeSlide === numSlides - 1 && index === 0)) {
              className += ' next-slide';
            }

            return (
              <div key={index} className={className}>
                <Link to={slide.link}>
                  {windowWidth <= 980 ? (
                    <img src={slide.mobileImage} alt={`Slide ${index}`} />
                  ) : (
                    <img src={slide.desktopImage} alt={`Slide ${index}`} />
                  )}
                </Link>
              </div>
            );
          })}
        </Slider>
      </section>
    );
  }
}
